import { z } from 'zod'

import { OFFICIAL_REPORT_FORM_FIELDS } from '../constant'
import { FormValuesType, timePattern } from '../schema'
import { ReportHeadway } from '@/types/officialReport'

const headwayPattern = /^\d+(\.\d{1,2})?$/

const headwayErrorMessage = 'Enter a number with up to two decimal places.'
const busStopErrorMessage = 'Enter the bus stop.'
const observedAtErrorMessage = 'Please enter a valid time.'

const validateHeadwayObject = ({
    data: { headway, busStop, observedAt },
    ctx,
    index,
}: {
    data: Partial<Omit<ReportHeadway, 'id'>>
    ctx: z.RefinementCtx
    index: number
}) => {
    if (!headway || !headwayPattern.test(headway.toString())) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: headwayErrorMessage,
            path: [`${OFFICIAL_REPORT_FORM_FIELDS.headways}.${index}.headway`],
        })
    }

    if (!busStop) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: busStopErrorMessage,
            path: [`${OFFICIAL_REPORT_FORM_FIELDS.headways}.${index}.busStop`],
        })
    }

    if (!observedAt || !timePattern.test(observedAt.toString())) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: observedAtErrorMessage,
            path: [`${OFFICIAL_REPORT_FORM_FIELDS.headways}.${index}.observedAt`],
        })
    }
}

export const validateHeadways = ({ data, ctx }: { data: FormValuesType; ctx: z.RefinementCtx }): void => {
    const headways = data[OFFICIAL_REPORT_FORM_FIELDS.headways] || []

    if (headways.length === 1 && headways[0]) {
        validateHeadwayObject({
            data: headways[0],
            ctx,
            index: 0,
        })
        return
    }

    const lastRow = headways.at(-1)
    const lastRowHasEnteredValues = lastRow && Object.values(lastRow).some((item) => !!item)
    const headwaysToCheck = lastRowHasEnteredValues ? headways : headways.slice(0, -1)

    headwaysToCheck.forEach((data, index) => {
        validateHeadwayObject({
            data,
            ctx,
            index,
        })
    })
}
